import React, { useEffect, useState } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import "./CustomerMobStar.css";
import { Link } from "react-router-dom";
import { Button, Col, Typography } from "antd";
import { useNavigate, useParams } from "react-router-dom";
// import { ReactComponent as CashIcon } from "../../../assets/icons/cash-wallet.svg";
import { ReactComponent as PointsIcon } from "../../../assets/icons/points-icon.svg";
import CustomTableWithPagination from "../../../components/CustomTableWithPagination/CustomTableWithPagination";
import { saveAs } from "file-saver";
import {
  useLazyGetmobStarHistoryQuery,
  useLazyGetDownloadCustMobStarReportsQuery,
} from "../../../apis/wallet";
import {
  // DashOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import {
  dateFormat,
  memberTypeIcon,
} from "../../../commonFuntions/CommonUtilFunctions";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import NoDataFound from "../../../components/EmptyTable/NoDataFound";
import CustomSelect from "../../../components/SelectableDropdown/CustomSelect/CustomSelect";
const { Text } = Typography;

const CustomerMobStar = () => {
  const navigate = useNavigate();
  const params = useParams();
  // const [searchedValue, setSearchedValue] = useState({});
  const [selectedFilter, setSelectedFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const options = [
    {
      key: 1,
      value: "Export",
      label: "Export",
    },
  ];
  const statusFilterOptions = [
    {
      key: 1,
      value: "credit",
      label: "Credit",
    },
    {
      key: 2,
      value: "debit",
      label: "Debit",
    },
    {
      key: 3,
      value: "",
      label: (
        <Col style={{ color: "#006644", fontWeight: "500" }}>Clear Status</Col>
      ),
    },
  ];
  const [
    mobStarHistoryApi,
    { data: mobStarHistoryData, isLoading, isFetching },
  ] = useLazyGetmobStarHistoryQuery();

  const [getDownloadCustomerMobStarReportapi, { isFetching: downloadReport }] =
    useLazyGetDownloadCustMobStarReportsQuery();

  const handleBackNavigate = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (params) {
      mobStarHistoryApi({ id: params?.id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  const handlePageChange = async (currPage) => {
    // let brandArray = [];
    // let categoriesArray = [];
    // brands.map((item) => brandArray.push(item.label));
    // categories.map((item) => categoriesArray.push(item.label));
    const params = {
      page: currPage,
      // ...(searchedValue && { search: searchedValue?.search }),
      // ...(brandArray.length && { brands: brandArray }),
      // ...(categoriesArray.length && { category: categoriesArray }),
    };
    setCurrentPage(currPage);
    await mobStarHistoryApi({ id: params?.id, ...params });
  };
  const handleExportApi = async () => {
    const param = {
      ...(selectedFilter && { type: selectedFilter }), // Use stored filter value
    };
    let response = await getDownloadCustomerMobStarReportapi({
      // ...(searchedValue.search && { search: searchedValue.search }),
      param: param,
      id: params?.id,
    });

    if (response?.status === "fulfilled") {
      // handlePdfDownload(response?.data?.data?.url);
      saveAs(response?.data?.data?.download_url);
    }
  };
  const handleFilterApi = (item) => {
    setSelectedFilter(item);
    const param = {
      ...(item && { type: item }),
    };
    mobStarHistoryApi({
      id: params?.id,
      param: param,
    });
  };
  const columns = [
    {
      title: "TRANSACTIONS",
      dataIndex: "description",
      key: "description",
      fixed: "left",
      width: "100px",
      render: (params, record) => {
        return (
          <Col style={{ display: "flex", flexDirection: "column" }}>
            {record?.details && record?.details?.order_id !== undefined ? (
              <Text style={{ fontsize: "14px", fontWeight: 500 }}>
                {" "}
                {"Order ID: "}
                <Link
                  style={{ color: "#1677ff", fontWeight: 500 }}
                  className="order-id-text"
                  to={`/admin/orders/order-details/${record?.details?.id}`}
                  // onClick={() => handleDetailNav(record)}
                  target="_blank"
                >
                  {`${
                    record?.details?.order_id || record?.details?.suborder_id
                  }`}
                </Link>
              </Text>
            ) : (
              <Text style={{ fontsize: "14px", fontWeight: 500 }}>
                {" "}
                Remarks: {record?.remarks}
              </Text>
            )}
            <Text
              style={{
                fontSize: "14px",
                fontWeight: 400,
                color: "#0a243f",
                opacity: 0.6,
              }}
            >{`${record?.tx_type} on ${dateFormat(record?.created_at)}`}</Text>
          </Col>
        );
      },
    },
    // {
    //   title: "POINTS",
    //   dataIndex: "points",
    //   key: "points",
    //   width: "50px",
    //   render: (params, record) => {
    //     return (
    //       <>
    //         <Text style={{ fontSize: "18px", opacity: 0.5, fontWeight: 500 }}>
    //           {record?.points}
    //         </Text>
    //       </>
    //     );
    //   },
    // },
    {
      title: "",
      dataIndex: "cash",
      key: "cash",
      width: "50px",
      align: "right",
      render: (params, record) => {
        const txType = record?.tx_type;
        const points = Math.round(record?.points || 0);
        const isPositiveType = txType === "EARN" || txType === "REFUND";
        const isNegativeType =
          txType === "REDEEM" || txType === "REVOKE" || txType === "EXPIRE";
        let sign = "";
        if (isPositiveType) sign = "+";
        else if (isNegativeType) sign = "-";
        else if (txType === "ADJUST") sign = points >= 0 ? "+" : "-";

        const color =
          sign === "+"
            ? "rgb(19,134,63)"
            : sign === "-"
            ? "rgb(211,47,47)"
            : undefined;
        const absPoints = Math.abs(points);
        const absAmount = Math.abs(points / 4 || 0).toFixed(2);

        return (
          <>
            <Col className="my-account-amount-container">
              <Text
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  float: "right",
                  color: color,
                }}
              >
                {sign}
                {absPoints} P
              </Text>
              <br />
              <Text
                style={{
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "#0a243f",
                  opacity: 0.6,
                }}
              >
                {sign} {"₹"} {absAmount}
              </Text>
            </Col>
          </>
        );
      },
    },
    // {
    //   title: "BALANCE",
    //   dataIndex: "balance",
    //   key: "balance",
    //   width: "50px",
    //   render: (params, record) => {
    //     return (
    //       <>
    //         <Text style={{fontSize: "18px", fontWeight: 500}}>
    //           ₹ {(record?.current_balace || 0).toFixed(2)}
    //         </Text>
    //       </>
    //     );
    //   },
    // },
  ];
  return (
    <Col className="customer-wallet-container">
      <Button
        className="btn"
        icon={<ArrowLeftOutlined />}
        onClick={handleBackNavigate}
      >
        BACK
      </Button>
      <Text className="customer-wallet-heading">mobSTAR Points</Text>

      <Col className="customer-wallet-body">
        <Col
          className="customer-mobstar-points"
          style={{ justifyContent: "space-between" }}
        >
          <Col className="wallet-points-align">
            <Col className="">
              <PointsIcon />
            </Col>
            <Col className="wallet-text-wrapper">
              <Text className="text-white">
                {mobStarHistoryData?.data[0]?.mobStarPoints?.points || 0}{" "}
                {" points "} (₹{" "}
                {mobStarHistoryData?.data[0]?.mobStarPoints?.actual_money ||
                  0.0 ||
                  "0.00"}
                )
                {/* <Text style={{ fontSize: "12px", fontWeight: 400, marginLeft: "5px" }}>
                
          
          </Text> */}
              </Text>
              {/* <Text className="text-white">
                Points Available
              </Text> */}
            </Col>
          </Col>
          {/* <Col className="wallet-points-align">
            <Col className="wallet-icon-wrapper">
              <PointsIcon />
            </Col>
            <Col className="wallet-text-wrapper">
              <Text className="cash-text">
               ₹  {mobStarHistoryData?.data[0]?.mobStarPoints?.actual_money || 0.00 || "--"}
              </Text>
              <Text className="earned-text">Balance</Text>
            </Col>
          </Col> */}
          <Col className="wallet-points-align">
            {memberTypeIcon?.[mobStarHistoryData?.data[0]?.mobStarPoints?.name]
              ?.icon || ""}
            <Text className="text-white">
              {memberTypeIcon?.[
                mobStarHistoryData?.data[0]?.mobStarPoints?.name
              ]?.name || ""}
            </Text>
          </Col>
        </Col>
        <Col
          style={{
            display: "flex",
            gap: "1rem",
            justifyContent: "space-between",
          }}
        >
          {/* <SearchInput
          size={"large"}
          placeholder={"Search by customer name, mobile no, email"}
          width={"400px"}
          getLibraryApi={getCustomerOrderReportApi}
          handleSearchedValue={handleSearchedValue}
          isLoading={isFetching}
        /> */}
          <CustomSelect
            placeholder={"Status Filter"}
            width={"150px"}
            options={statusFilterOptions}
            handleChange={handleFilterApi}
            // value={isLoading ? <LoadingOutlined /> : "Status Filter"}
            disabled={isLoading ? true : false}
            loading={isLoading}
          />
          <CustomSelect
            placeholder={"Export"}
            width={"150px"}
            options={options}
            handleChange={handleExportApi}
            value={downloadReport ? <LoadingOutlined /> : "EXPORT"}
            disabled={downloadReport ? true : false}
            loading={downloadReport}
          />
        </Col>
        <CustomTableWithPagination
          className="order-list-table"
          //   tableExpandable={defaultExpandable}
          //   tableDataSource={tableDataSource || []}
          tableDataSource={mobStarHistoryData?.data || []}
          // tableDataSource={tableDataSource || []}
          tableColumns={columns}
          locale={{
            emptyText: isFetching ? (
              <TableSkeleton length={10} />
            ) : (
              <NoDataFound text={"No transaction found!"} />
            ),
          }}
          scroll={{ x: "100%" }}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          itemsPerPage={30}
          totalEntries={
            !isLoading && mobStarHistoryData?.data?.pagination?.total_entries
          }
        />
      </Col>
    </Col>
  );
};

export default CustomerMobStar;
